export const escapeRegexChars = (s: string): string => {
  return !s ? s : s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
};
